<template>
    <div class="code-edit" ref="code-edit"></div>
</template>
<script>
import moment from 'moment';
import { loadScript } from '../service/requestApi.js';

export default {
    props: {
        name: String
    },
    data() {
        return {
            editor: null,
            loading: false
        }
    },
    components: {
    },
    methods: {
        getValue() {
            let jsonVal = this.editor.getValue();
            return jsonVal;
        },
        setValue(val) {
            if (this.editor) {
                try {
                    this.editor.setValue(JSON.stringify(JSON.parse(val), null, 4));
                } catch(e) {
                    console.log(e);
                }
            } else {
                console.log('code editor未初始化');
            }
        }
    },
    computed: {
    },
    created() {
    },
    async mounted() {
        this.loading = true;
        await loadScript('/static/ace/src-min/ace.js');
        await loadScript('/static/ace/src-min/ext-language_tools.js');
        this.editor = ace.edit(this.$refs["code-edit"]);
        this.editor.$blockScrolling = Infinity;
        this.editor.setFontSize(16);
        // this.editor.setTheme("ace/theme/monokai");
        this.editor.session.setMode("ace/mode/jsoniq");
        ace.require('ace/ext/language_tools');
        this.editor.setOptions({
            enableBasicAutocompletion: true,
            enableSnippets: true,
            enableLiveAutocompletion: true
        });
        this.loading = false;
        this.$emit('init-ace-complete');
    }
}
</script>
<style lang="less" scoped>

    .code-edit {
        height: 100%;
    }

</style>



// WEBPACK FOOTER //
// src/components/codeEditor.vue